module.exports = __webpack_public_path__ + "img/DSC_2859-xs.32838d25.png";